import { useEffect } from 'react';
import {
    LegacyOttTrailerPlayerBaseInfoContent,
    MovieOnlineStreamsFragment,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { StreamsWatchingRejectionReason } from '../../../error-boundary-context/error-map/map';
import { useHandleError } from '../../../error-boundary-context/context';

type Streams =
    | MovieOnlineStreamsFragment['streams']
    | LegacyOttTrailerPlayerBaseInfoContent['streams'];

export const useEmptyStreamsGuard = (streams?: Streams) => {
    const handleError = useHandleError();

    useEffect(() => {
        if (!streams?.length) {
            handleError(StreamsWatchingRejectionReason.EMPTY_OTT_STREAMS);
        }
    }, [handleError, streams]);
};
